import { EventEmitter, Component, ChangeDetectionStrategy, ChangeDetectorRef, Input, Output, NgModule } from '@angular/core';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { ResponsiveService, B2CSharedPipeModule } from 'b2c-ui/core';
import { tap } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { NzModalModule, NzButtonModule, NzGridModule } from 'ng-zorro-antd';
import { TimeoutIcon, B2cUiIconModule, B2CUiIconService } from 'b2c-ui-icon';

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-time-out.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from 'b2c-ui/core';
import * as ɵngcc2 from 'ng-zorro-antd';
import * as ɵngcc3 from 'b2c-ui-icon';
import * as ɵngcc4 from '@angular/common';

const _c0 = function (a0) { return { "flex-column": a0 }; };
const _c1 = function (a0, a1) { return { "mr-3": a0, "mb-3": a1 }; };
class B2CTimeOutComponent {
    /**
     * @param {?} responsiveService
     * @param {?} cdRef
     */
    constructor(responsiveService, cdRef) {
        this.responsiveService = responsiveService;
        this.cdRef = cdRef;
        this.logout = new EventEmitter();
        this.continue = new EventEmitter();
        this._isMobile = false;
    }
    /**
     * Set Mobile View
     * @param {?} value
     * @return {?}
     */
    set isMobile(value) {
        this._isMobile = coerceBooleanProperty(value);
    }
    /**
     * @ignore
     * @return {?}
     */
    get isMobile() {
        return this._isMobile;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.responsiveService
            .isMobileWeb()
            .pipe(tap((/**
         * @param {?} mobile
         * @return {?}
         */
        (mobile) => {
            this.isMobile = mobile;
            this.cdRef.markForCheck();
        })))
            .subscribe();
    }
    /**
     * @return {?}
     */
    closeModal() {
        this.showModal = false;
    }
}
B2CTimeOutComponent.ɵfac = function B2CTimeOutComponent_Factory(t) { return new (t || B2CTimeOutComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.ResponsiveService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
B2CTimeOutComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: B2CTimeOutComponent, selectors: [["b2c-time-out"]], inputs: { isMobile: "isMobile", showModal: "showModal", timeLeft: "timeLeft" }, outputs: { logout: "logout", continue: "continue" }, decls: 15, vars: 14, consts: [["nzWrapClassName", "vertical-center-modal", 3, "nzVisible", "nzFooter", "nzMaskClosable", "nzClosable"], [1, "d-flex", "flex-column", "align-items-center", "justify-content-center"], ["name", "timeoutIcon", 1, "pt-4"], [1, "b2c-time-out-text", "pt-4"], [1, "b2c-time-out-text", "text-center", "mb-0"], [1, "d-flex", "space-between", "py-4", 3, "ngClass"], ["nz-button", "", "nzType", "outline", 3, "ngClass", "click"], ["nz-button", "", "nzType", "primary", 3, "click"]], template: function B2CTimeOutComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "nz-modal", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelement(2, "b2c-ui-icon", 2);
        ɵngcc0.ɵɵelementStart(3, "h3", 3);
        ɵngcc0.ɵɵtext(4, "Session Timeout");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "p", 4);
        ɵngcc0.ɵɵtext(6, " Your session is about to expire.");
        ɵngcc0.ɵɵelement(7, "br");
        ɵngcc0.ɵɵtext(8);
        ɵngcc0.ɵɵpipe(9, "minute");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "div", 5);
        ɵngcc0.ɵɵelementStart(11, "button", 6);
        ɵngcc0.ɵɵlistener("click", function B2CTimeOutComponent_Template_button_click_11_listener() { return ctx.logout.emit(); });
        ɵngcc0.ɵɵtext(12, "Log Out");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(13, "button", 7);
        ɵngcc0.ɵɵlistener("click", function B2CTimeOutComponent_Template_button_click_13_listener() { return ctx.continue.emit(); });
        ɵngcc0.ɵɵtext(14, "Continue Session");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("nzVisible", ctx.showModal)("nzFooter", null)("nzMaskClosable", false)("nzClosable", false);
        ɵngcc0.ɵɵadvance(8);
        ɵngcc0.ɵɵtextInterpolate1(" You will be logged out in ", ɵngcc0.ɵɵpipeBind1(9, 7, ctx.timeLeft), ". ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(9, _c0, ctx.isMobile));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(11, _c1, !ctx.isMobile, ctx.isMobile));
    } }, directives: [ɵngcc2.NzModalComponent, ɵngcc3.B2CUiIconComponent, ɵngcc4.NgClass, ɵngcc2.NzButtonComponent], pipes: [ɵngcc1.MinutePipe], encapsulation: 2, changeDetection: 0 });
/** @nocollapse */
B2CTimeOutComponent.ctorParameters = () => [
    { type: ResponsiveService },
    { type: ChangeDetectorRef }
];
B2CTimeOutComponent.propDecorators = {
    timeLeft: [{ type: Input }],
    showModal: [{ type: Input }],
    logout: [{ type: Output }],
    continue: [{ type: Output }],
    isMobile: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(B2CTimeOutComponent, [{
        type: Component,
        args: [{
                selector: 'b2c-time-out',
                template: "<nz-modal nzWrapClassName=\"vertical-center-modal\" [nzVisible]=\"showModal\" [nzFooter]=\"null\" [nzMaskClosable]=\"false\" [nzClosable]=\"false\">\r\n  <div class=\"d-flex flex-column align-items-center justify-content-center\">\r\n    <b2c-ui-icon class=\"pt-4\" name=\"timeoutIcon\"></b2c-ui-icon>\r\n    <h3 class=\"b2c-time-out-text pt-4\">Session Timeout</h3>\r\n    <p class=\"b2c-time-out-text text-center mb-0\">\r\n      Your session is about to expire.<br> \r\n      You will be logged out in {{ timeLeft | minute }}. \r\n    </p>\r\n    <div class=\"d-flex space-between py-4\" [ngClass]=\"{'flex-column': isMobile}\">\r\n        <button nz-button [ngClass]=\"{'mr-3': !isMobile, 'mb-3': isMobile}\" nzType=\"outline\" (click)=\"logout.emit()\">Log Out</button>\r\n        <button nz-button nzType=\"primary\" (click)=\"continue.emit()\">Continue Session</button>\r\n    </div>\r\n  </div>\r\n</nz-modal>",
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: ɵngcc1.ResponsiveService }, { type: ɵngcc0.ChangeDetectorRef }]; }, { logout: [{
            type: Output
        }], continue: [{
            type: Output
        }], isMobile: [{
            type: Input
        }], showModal: [{
            type: Input
        }], timeLeft: [{
            type: Input
        }] }); })();
if (false) {
    /**
     * Set the Remaining Time Left for the Current Session
     * @type {?}
     */
    B2CTimeOutComponent.prototype.timeLeft;
    /**
     * Set The Visibility of The Modal
     * @type {?}
     */
    B2CTimeOutComponent.prototype.showModal;
    /** @type {?} */
    B2CTimeOutComponent.prototype.logout;
    /** @type {?} */
    B2CTimeOutComponent.prototype.continue;
    /**
     * @type {?}
     * @private
     */
    B2CTimeOutComponent.prototype._isMobile;
    /**
     * @type {?}
     * @private
     */
    B2CTimeOutComponent.prototype.responsiveService;
    /**
     * @type {?}
     * @private
     */
    B2CTimeOutComponent.prototype.cdRef;
}

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-time-out.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const ICONS = [TimeoutIcon];
class B2CTimeOutModule {
    /**
     * @param {?} b2cIconService
     */
    constructor(b2cIconService) {
        this.b2cIconService = b2cIconService;
        this.b2cIconService.registerIcons([...ICONS]);
    }
}
B2CTimeOutModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: B2CTimeOutModule });
B2CTimeOutModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function B2CTimeOutModule_Factory(t) { return new (t || B2CTimeOutModule)(ɵngcc0.ɵɵinject(ɵngcc3.B2CUiIconService)); }, imports: [[
            CommonModule,
            NzModalModule,
            NzButtonModule,
            NzGridModule,
            B2cUiIconModule,
            B2CSharedPipeModule
        ]] });
/** @nocollapse */
B2CTimeOutModule.ctorParameters = () => [
    { type: B2CUiIconService }
];
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(B2CTimeOutModule, { declarations: function () { return [B2CTimeOutComponent]; }, imports: function () { return [CommonModule,
        NzModalModule,
        NzButtonModule,
        NzGridModule,
        B2cUiIconModule,
        B2CSharedPipeModule]; }, exports: function () { return [B2CTimeOutComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(B2CTimeOutModule, [{
        type: NgModule,
        args: [{
                declarations: [B2CTimeOutComponent],
                exports: [B2CTimeOutComponent],
                imports: [
                    CommonModule,
                    NzModalModule,
                    NzButtonModule,
                    NzGridModule,
                    B2cUiIconModule,
                    B2CSharedPipeModule
                ]
            }]
    }], function () { return [{ type: ɵngcc3.B2CUiIconService }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    B2CTimeOutModule.prototype.b2cIconService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: public_api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-ui-time-out.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { B2CTimeOutComponent, B2CTimeOutModule };


//# sourceMappingURL=b2c-ui-time-out.js.map